import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { userTree } from "@/service/structure";
import { userTreeChange } from "@/libs/common";
import identityIcon from "@/libs/identityIcon";
import _ from "lodash";
export default {
  name: "STree",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    tag: {
      type: null,
      default() {
        return null;
      }
    },
    removeUser: {
      type: Boolean,
      default() {
        return false;
      }
    },
    checkTree: {
      type: Array,
      default() {
        return [];
      }
    },
    disabledOrg: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      dataTree: [],
      identityIcon,
      search: {
        value: ""
      }
    };
  },
  computed: {
    data() {
      if (this.search.value) {
        return this.mapTree(this.search.value, this.dataTree);
      } else {
        return this.dataTree;
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.init();
      } else {
        this.clean();
      }
    }
  },
  methods: {
    mapTree(value, arr) {
      let newarr = [];
      arr.forEach(element => {
        if (element.title.indexOf(value) > -1) {
          // 判断条件
          element.expand = true;
          newarr.push(element);
        } else {
          if (element.children && element.children.length > 0) {
            let redata = this.mapTree(value, element.children);
            if (redata && redata.length > 0) {
              let obj = {
                ...element,
                expand: true,
                children: redata
              };
              newarr.push(obj);
            }
          }
        }
      });
      return newarr;
    },
    /*
     ** 获取用户所在组织树
     */
    async getTree() {
      let res = await userTree();
      if (res.data && res.data.result === 0) {
        let data = userTreeChange(res.data.retVal);
        this.userInChildren(data);
        this.DG(data);
        this.echoCheck(data);
        this.dataTree = data;
      }
    },
    clean() {
      this.search.value = "";
      this.dataTree = [];
    },
    /*
     ** 回显已经选中项
     */
    echoCheck(data) {
      this.$emit("echoCheck", data);
    },
    /*
     ** 将成员加入children中，并做标记, 一起跟部门一样呈现树形结构
     */
    userInChildren(data) {
      // 如果removeUser为true，表示不现实用户
      if (this.removeUser) {
        return;
      }
      let changeAdd = arr => {
        arr.forEach(v => {
          v.name = v.userName || v.name;
          v.organizationUsers && v.organizationUsers.forEach(item => {
            item.isUserByTree = true;
          });
          v.children = v.organizationUsers ? [...v.children, ...v.organizationUsers] : [];
          let children = v.children;
          if (children && children.length > 0) {
            changeAdd(children);
          }
        });
      };
      changeAdd(data);
    },
    /*
     ** 递归
     */
    DG(data) {
      let change = arr => {
        arr.forEach(v => {
          this.disposeTree(v);
          let children = v.children;
          if (children && children.length > 0) {
            change(children);
          }
        });
      };
      change(data);
    },
    /*
     ** 对树形数据进行特殊处理
     */
    disposeTree(v) {
      this.setTitle(v);
      this.setExpand(v);
      this.setDisabled(v);
      this.setTreeIcon(v);
      this.expendOne(v);
      this.setCheckOnOrOff(v);
      this.setOnChangeCheck(v);
      // this.echoCheck();
    },
    /*
     ** 设置title
     */
    setTitle(v) {
      v.title = v.name;
    },
    /*
     ** 设置expand
     */
    setExpand(v) {
      v.expand = false;
    },
    /*
     * 设置禁用项
     */
    setDisabled(v) {
      // 是部门且设置不可编辑
      v.disabled = !v.isUserByTree && this.disabledOrg;
    },
    /*
     ** 默认展开第一行
     */
    expendOne(v) {
      if (v.parentId === v.orgId) {
        v.expand = true;
      }
    },
    /*
     ** 设置不可被选中项
     */
    setOnChangeCheck(v) {
      if (this.tag) {
        switch (this.tag.tagTarget) {
          case "USER":
            if (!v.isUserByTree || v.orgId === v.parentId) {
              v.disabled = true;
            }
            break;
          case "ORG":
            if (v.isUserByTree || v.orgId === v.parentId) {
              v.disabled = true;
            }
            break;
        }
      }
    },
    /*
     ** 设置已勾选部门或者成员
     */
    // echoCheck(v) {
    //   let checkTree = this.checkTree;
    //   let index = checkTree.findIndex((vv) => {
    //     if (vv.type === "USER") {
    //       return vv.userId === v.userId;
    //     } else if (vv.type === "ORG") {
    //       return vv.orgId === v.orgId;
    //     }
    //   });
    //   if (index > -1) {
    //     v.isCheck = true;
    //     checkTree[index] = v;
    //     this.checkTree = [...checkTree];
    //   }
    // },

    /*
     ** 设置图标
     */
    setTreeIcon(v) {
      const h = this.$createElement;
      let style = {
        marginRight: "5px",
        color: "#2d8cf0"
      };
      let styleCheck = {
        marginLeft: "5px",
        color: "#dddddd"
      };
      v.render = (h, params) => {
        let iconType = isUserByTree => {
          if (isUserByTree) {
            return identityIcon["USER"];
          } else {
            return identityIcon["ORG"];
          }
        };
        return h("span", [h("Icon", {
          "style": {
            ...style
          },
          "attrs": {
            "type": iconType(params.data.isUserByTree)
          }
        }), h("span", {
          "domProps": {
            "innerHTML": (() => {
              return params.data.name.replace(_.trim(this.search.value), match => {
                if (match) {
                  return `<span style="color: red;">${match}</span>`;
                } else {
                  return `<span>${match}</span>`;
                }
              });
            })()
          }
        }), params.data.isCheck ? h("Icon", {
          "style": {
            ...styleCheck
          },
          "attrs": {
            "color": "#3D7FFF",
            "type": "md-checkmark"
          }
        }) : ""]);
      };
    },
    /*
     ** 设置是否勾选标记
     */
    setCheckOnOrOff(v) {
      v.isCheck = false;
    },
    onSelectChangeTree(arr, item) {
      console.log("这里拿到的是啥", item);
      this.$emit("changePush", item);
    },
    init() {
      this.getTree();
    }
  }
};